//////////////////////////////////////////////////////////////////////
//
//  10/02/18
//  src/containers/MainLogin.js
//
//  This file is the top level MainLogin javascript file.
//

import React, { Component } from 'react';
import './MainLogin.css';

class MainLogin extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      email : "",
      password : "",
    };
  }

  handleChange = e => {
    this.setState({
      [ e.target.name ] : e.target.value
    });
  };

  render() {
    const { heading } = this.props;

    return (
      <div id="MainLoginTop">
        <h2 id="MainLoginTitle">{ heading }</h2>

        <div id="MainLoginBody">
          <label id="MainLoginEmail" htmlFor="email">Email:</label>
          <input 
            autoComplete="off"
            className="MainLoginFormCtrl"
            size="40"
            id="email" 
            name="email" 
            onChange={ this.handleChange } 
            type="text"
          />

          <label id="MainLoginPword" htmlFor="password">Password:</label>
          <input 
            autoComplete="off"
            className="MainLoginFormCtrl"
            size="40"
            id="password" 
            name="password" 
            onChange={ this.handleChange } 
            type="password"
          />
        </div>

      </div>
    );
  }
}

export default MainLogin;




// WEBPACK FOOTER //
// ./src/containers/MainLogin.js